<template>
	<div class="shop qjc-relative">
		<ul class="list qjc-clearfix">
			<li v-for="item in list" :key="item.title" class="qjc-fl">
				<img @click="to(item.url)" class="qjc-wid-100" :src="require('@/assets/images/'+ item.img +'.png')" alt="商品展示图">
				<h4 @click="to(item.url)" class="qjc-fts-30 qjc-c-fff qjc-texta-l">{{ item.title }}</h4>
			</li>
		</ul>
		
		<create-code></create-code>
		
	</div>
</template>

<script>
	import createCode from '@/components/createCode'
	
	export default{
		name: 'shop',
		data() {
			return {
				list: [
					{ title: 'PREVENTA 低氘水', img: 'PREVENTA_img1', url: '/shop/detail' },
					{ title: '欧姆龙温热电极式低频理疗仪', img: 'omron', url: 'https://item.jd.com/100006108643.html' },
					{ title: '欧姆龙电子血压计', img: 'omron_hem7124', url: 'https://item.jd.com/1726938.html' },
					{ title: 'Move Free益节 氨糖维骨力', img: 'schiff', url: 'https://item.jd.hk/100009287096.html' },
					{ title: 'Swisse斯维诗 奶蓟草护肝片', img: 'swisse', url: 'https://item.jd.hk/1909882.html' },
					{ title: '金钙尔奇 碳酸钙维D3元素片', img: 'gaierqi', url: 'https://item.yiyaojd.com/4397416.html' },
					{ title: '三诺血糖试纸测试仪', img: 'sinocare', url: 'https://item.jd.com/4737030.html' },
					{ title: 'Swisse斯维诗男士复合维生素', img: 'swisse2', url: 'https://item.jd.hk/1909867.html' }
				]
			}
		},
		components: {
			createCode
		},
		methods: {
			to(url) {
				if(/^\//.test(url)){
					this.$router.push(url);
				}else{
					window.location.href = url;
				}
			}
		}
		
	}
</script>

<style lang="scss" scoped>
	.shop{
		height: 9.9rem;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		
		.list{
			height: 100%;
			padding: 0.44rem 0.68rem;
			overflow: auto;
			
			li{
				width: 25%;
				padding: 0.16rem 0.1rem;
				overflow: hidden;
				
				img{
					height: 4.22rem;
				}
				h4{
					font-weight: 400;
					padding: 0.1rem 0.12rem;
					line-height: 0.42rem;
					white-space: nowrap;
				}
			}
		}
		
		
	}
</style>

